import React, { useState } from 'react';

import Axios from 'axios';
import { Formik, Field } from 'formik';

import styled from 'styled-components';

import { forceReloadTransaction } from '@hooks/API/UseTransaction';

import { Loading } from '@components/Gui/Loading';
import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import { NWTextAreaCharCounter } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const Container = styled.div`
    padding: 8px 0;
    //border-bottom: 1px solid ${(props) => props.theme.LighterBorderColor};

    .transaction-details {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 1rem;

        .transaction-details-left {
            flex: 1 1 0;

            .transaction-title {
                margin-bottom: 0.5rem;
            }
            p {
                margin-bottom: 0.5rem;
            }
        }
        .transaction-details-right {
            flex: 0 0 4rem;
        }
    }
`;

const TransactionStatementDescriptionForm = ({ transaction, statement, onCancel, onSave }) => {
    const [touchForm, setTouchForm] = useState(false);

    const submitForm = async (values, setStatus, setSubmitting) => {
        setSubmitting(true);
        let data = {
            TransactionID: transaction.ID,
            StatementID: statement.ID,
            description: values.Description,
        };

        try {
            await Axios.put(`/transactions/${transaction.Family}/modifyStatementDescription`, data);
            forceReloadTransaction(transaction.ID);
            setTouchForm(false);
            setSubmitting(false);
            if (onSave) {
                onSave();
            }
        } catch (error) {
            //TODO: manage error on api call, may be by adding an ErrorMessage to the state and a condition to show it in render.
            setSubmitting(false);
            console.error('errore', error);
        }
    };

    let initialValues = {
        Description: statement ? statement.Description : '',
    };

    return statement ? (
        <Container>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    setStatus();
                    submitForm(values, setStatus, setSubmitting);
                }}
            >
                {({ isSubmitting, values, handleSubmit }) => {
                    return (
                        <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit} layout="vertical">
                            <Field
                                component={NWTextAreaCharCounter}
                                label="Description"
                                name="Description"
                                type="text"
                                value={values.Description}
                                maxLength={1000}
                                autoSize={{ minRows: 3, maxRows: 5 }}
                            />
                            <NwFormButtonsBar
                                left={
                                    <NwCancelButton
                                        disabled={isSubmitting}
                                        onClick={() => {
                                            setTouchForm(false);
                                            if (onCancel) {
                                                onCancel();
                                            }
                                        }}
                                    />
                                }
                                right={
                                    <NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />
                                }
                            />
                        </NwForm>
                    );
                }}
            </Formik>
        </Container>
    ) : (
        <Loading />
    );
};

export default TransactionStatementDescriptionForm;
